import React from "react";
import { Alert as AlertAntd, Col, Row, Typography } from "antd";
import { JoinedAlert } from "../../../types";
import { ReactComponent as MosquitoIconSvg } from "../../../assets/icons/MosquitoVector.svg";

const { Text } = Typography;

type Props = {
  item: JoinedAlert;
  onClick?: (id: string) => void;
};

const AlertDialog: React.FC<Props> = ({ item }) => {
  // const message = (item?.message || "").replace(/^\[.+\]/, "");

  return (
    <div key={item?._id} className="alert-dialog-container">
      <AlertAntd
        // onClick={() => onClick && onClick(item?._id)}
        message={
          <Col>
            <Row>
              <Text strong>{"Trap maintenance needed"}</Text>
            </Row>
            {item?.trap_name && (
              <Row>
                <Text>{item?.trap_name} </Text>
              </Row>
            )}
            <Row>
              <Text>{item?.device_name} </Text>
            </Row>
          </Col>
        }
        type="warning"
        showIcon
        icon={<MosquitoIconSvg width={24} height={24} fill="#F97316" />}
      />
    </div>
  );
};

export default AlertDialog;
